import * as React from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { MOBILE_MAX_WIDTH } from 'Src/me/pages/guest/proposals/new/consts';

const initialViewWidth = window.innerWidth;

export const useCurrentDevice = () => {
  const [viewWidth, setViewWidth] = React.useState<number>(initialViewWidth);
  const [isMobileView, setIsMobileView] = React.useState<boolean>(initialViewWidth <= MOBILE_MAX_WIDTH);
  const setViewWidthHandler = useDebouncedCallback(() => setViewWidth(window.innerWidth), 200);

  // リサイズ時にviewWidthを更新
  React.useEffect(() => {
    setViewWidthHandler(); // 初期値判定
    window.addEventListener('resize', setViewWidthHandler);

    return () => window.removeEventListener('resize', setViewWidthHandler);
  }, [setViewWidthHandler]);

  // viewWidthが更新されたらisMobileViewを更新
  React.useEffect(() => {
    setIsMobileView(viewWidth <= MOBILE_MAX_WIDTH);
  }, [viewWidth]);

  return {
    viewWidth,
    isMobileView,
  };
};
